import { useAxios } from "auth-sdk";
import { useCustomerAppConfig } from "undercarriage";
import { useSuspenseQuery, type UseSuspenseQueryResult } from "@tanstack/react-query";
import { type AxiosResponse } from "axios";

import type { ContractsCompletionResponse } from "../../funds-requests";

export const useGetContractTasksQuery = (): UseSuspenseQueryResult<ContractsCompletionResponse> => {
  const client = useAxios();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const requestPath = `/${customerDomain}/financing/contracts/task-list`;

  return useSuspenseQuery({
    queryKey: ["getContractTasks"],
    queryFn: () => client.get<ContractsCompletionResponse>(requestPath),
    select: ({ data }: AxiosResponse<ContractsCompletionResponse>) => data,
  });
};
